module.exports = __webpack_public_path__ + "img/ANTENNA 3 BW.75e442d.svg";